const WEB_PROTOCOLS = new Set(['http:', 'https:'])

function getConfiguredClientOrigin(): string | null {
  const clientHost = ENV.ClientHost?.trim()
  if(!clientHost) {
    return null
  }
  try {
    return new URL(clientHost).origin
  } catch {
    return null
  }
}

export function getInternalLinkOrigin(): string {
  const configuredOrigin = getConfiguredClientOrigin()
  if(configuredOrigin) {
    return configuredOrigin
  }
  if(WEB_PROTOCOLS.has(window.location.protocol)) {
    return window.location.origin
  }
  const fallbackHost = (ENV.InternalLinkHosts ?? [])[0]

  return fallbackHost ? `https://${fallbackHost}` : window.location.origin
}
